import { apiRequestGet } from 'mastodon/api';
import type { Account } from 'mastodon/models/account';

export const apiGetFavouritedBy = (statusId: string) =>
  apiRequestGet<Account[]>(`v1/statuses/${statusId}/favourited_by`);
